module.exports = __webpack_public_path__ + "img/资源 26.7ef42196.png";